import {uniqueId, result} from 'lodash';
import pluralize from 'pluralize';

export default class ColumnModel {
    table = null;
    pk = false;
    customLabel = '';
    group = '';

    constructor(columnData, table) {
        Object.assign(this, columnData);
        if (table) {
            this.table = table;
        }
        this.id = this.id || uniqueId('column');
        this.pk = this.name === 'id';
        this.type = this.base_type || this.type;
    }

    matchesQuery(searchQuery) {
        const regex = new RegExp(searchQuery, 'i');
        return regex.test(`${result(this.table, 'label')} ${this.label}`);
    }

    getFullName(shorten = false) {
        let tableName = result(this.table, 'label');
        if (this.pk && shorten) {
            return tableName;
        } else {
            if (tableName) {
                tableName = pluralize(tableName, 1);
            }
            return `${tableName} ${this.label}`;
        }
    }

    get label() {
        return this.customLabel || this.title_name || this.name;
    }

    set label(label) {
        this.customLabel = label;
    }

    get fullName() {
        return this.getFullName(true);
    }

    get schema() {
        return result(this.table, 'schema');
    }

    get datasource() {
        return result(this.schema, 'datasource');
    }

    get sqlName() {
        return this.table ? `${this.table.sqlName}.\`${this.sql_name || this.title_name.replace(/\s/g, '')}\`` : null;
    }
}
